import t from "@dialpad/dialtone-icons/illustrations.js";
const o = t, a = {
  ILLUSTRATION_NAMES: o
};
export {
  o as ILLUSTRATION_NAMES,
  a as default
};
//# sourceMappingURL=illustration-constants.js.map
